import React from "react";
import * as Components from "./index.styles";
import { TableDatabase } from "../../components";
import HeaderComponent from "../../components/common/HeaderSectionComponent";
import CalendarRangePicker from "../../components/paymentCustomerComponents/ModalDateRange";
import moment from "moment";
import { IRecord } from "../../interfaces/record";
import { Spinner } from "react-rainbow-components";
import * as DetailComponents from "../../components/historyRecordComponents/DetailComponnents";
import { getRecordsCase } from "../../services/record.service";
import { GetErrorMessage } from "../../functions/error";
import { useError } from "../../store/ErrorModal";

const HistoryRecordPage = () => {
  const [initialDate, setInitialDate] = React.useState<Date>(
    new Date("2021-09-25")
  );
  const [finaleDate, setFinaleDate] = React.useState<Date>(new Date());
  const [searchKey, setSearchKey] = React.useState<string>("");
  const [record, setRecord] = React.useState<IRecord[]>([]);
  const [dataForShow, setDataForShow] = React.useState<IRecord[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { onError } = useError();
  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const recordData = await getRecordsCase();
      const recordDataItem = recordData.data.filter((item: IRecord) => {
        if (!item.type || item.type === "product") return false;
        return true;
      });
      setRecord(recordDataItem);
    } catch (error) {
      setIsLoading(false);
      onError(GetErrorMessage(error));
    }
    setIsLoading(false);
  }, [onError]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  React.useEffect(() => {
    if (!record || record.length === 0) return;

    const formatDate = (date: string | number | Date) =>
      new Date(moment(date).format("YYYY-MM-DD"));

    const dateData = record.filter((item) => {
      if (
        formatDate(item.timeStamp) < formatDate(initialDate || new Date()) ||
        formatDate(item.timeStamp) > formatDate(finaleDate || new Date())
      )
        return false;
      return true;
    });

    const tagString = (tags: string[]) => {
      let tag = "";
      tags.forEach((item) => {
        tag += item;
      });
      return tag;
    };

    const nData = dateData.filter((item) => {
      if (!item.firstName || !item.lastName || !item.displayName) return false;

      item.summary = item.summary || "";
      item.product.productName = item.product.productName || "";
      const tags = item.tags || [];
      return (
        item.firstName.includes(searchKey) ||
        item.lastName.includes(searchKey) ||
        item.displayName.includes(searchKey) ||
        item.product.productName.includes(searchKey) ||
        tagString(tags).includes(searchKey) ||
        item.summary.includes(searchKey)
      );
    });
    nData.sort(
      (a, b) =>
        new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime()
    );
    setDataForShow(nData);
  }, [searchKey, setSearchKey, initialDate, finaleDate, record]);

  const convertData = (dataUsers: IRecord[]) => {
    return dataUsers.map((item: IRecord, index: number) => [
      <DetailComponents.Timestamp key={index} timestamp={item.timeStamp} />,
      <DetailComponents.ProfileComponent
        name={item.firstName + " " + item.lastName}
        pictureUrl={item.imageUrl}
        displayName={item.displayName}
      />,
      <DetailComponents.Product
        productName={item.product.productName}
        productPrice={item.product.price}
      />,
      <DetailComponents.Summary key={index} summary={item.summary || ""} />,
      <DetailComponents.RenderDoctor key={index} doctorId={item.doctorId} />,
    ]);
  };

  const header = [
    "วันที่บันทึก",
    "ชื่อลูกค้า",
    "ประเภทการรักษา",
    "อาการโดยสรุป",
    "แพทย์ที่ทำการรักษา (Id)",
  ];

  return (
    <Components.Container>
      <Components.HeaderSection>
        {HeaderComponent({
          title: "History Record",
          subheader: "ประวัติการรักษา",
        })}
        <Components.ContainerSeachData>
          <Components.ContainerSearce>
            <p>ค้นหา</p>
            <Components.SearchInput
              placeholder="ชื่อ / ชื่อไลน์ / แพคเกจ / tags"
              onChange={(event) => setSearchKey(event.target.value)}
            />
          </Components.ContainerSearce>
          <CalendarRangePicker
            initalDate={setInitialDate}
            finaleDate={setFinaleDate}
          />
        </Components.ContainerSeachData>
      </Components.HeaderSection>
      <Components.SectionBodyContainer>
        {!isLoading ? (
          <TableDatabase header={header} tableRows={convertData(dataForShow)} />
        ) : (
          <Spinner size="large" />
        )}
      </Components.SectionBodyContainer>
    </Components.Container>
  );
};

export default HistoryRecordPage;
